export enum MANDATORY_FIELDS_ROUTES {
  ROOT = 'mandatory-fields',
}
